import React, { FC } from 'react';

import ReadingsPage from "@/components/readings/ReadingsPage";
import { Medium } from "@/constants/mediums";

const HeatReadingsPage: FC = () => {
  return <ReadingsPage medium={Medium.heat} />;
};

export default HeatReadingsPage;
